import React, { useMemo, useState } from 'react';
import { ChevronLeftIcon, CalendarIcon, MapPinIcon, MinusIcon, PlusIcon, SaveIcon } from 'lucide-react';
interface GarmentFormProps {
  areaName: string;
  onBack: () => void;
  onSave: () => void;
}
const CATEGORIES = [{
  id: 'sabanas',
  name: 'Sábanas'
}, {
  id: 'fundas',
  name: 'Fundas'
}, {
  id: 'batas',
  name: 'Batas'
}, {
  id: 'pijamas',
  name: 'Pijamas'
}, {
  id: 'toallas',
  name: 'Toallas'
}, {
  id: 'uniformes',
  name: 'Uniformes'
}, {
  id: 'cobertores',
  name: 'Cobertores'
}];
export function GarmentForm({
  areaName,
  onBack,
  onSave
}: GarmentFormProps) {
  const [counts, setCounts] = useState<Record<string, number>>({});
  const [otrosCount, setOtrosCount] = useState(0);
  const [otrosDesc, setOtrosDesc] = useState('');
  const [observaciones, setObservaciones] = useState('');
  const [responsable, setResponsable] = useState('');
  const handleIncrement = (id: string) => {
    setCounts(prev => ({
      ...prev,
      [id]: (prev[id] || 0) + 1
    }));
  };
  const handleDecrement = (id: string) => {
    setCounts(prev => ({
      ...prev,
      [id]: Math.max(0, (prev[id] || 0) - 1)
    }));
  };
  const totalItems = useMemo(() => {
    const catsTotal = Object.values(counts).reduce((sum, count) => sum + count, 0);
    return catsTotal + otrosCount;
  }, [counts, otrosCount]);
  const now = new Date();
  const dateString = `${now.toLocaleDateString('es-ES')} ${now.toLocaleTimeString('es-ES', {
    hour: '2-digit',
    minute: '2-digit'
  })}`;
  return <div className="flex flex-col h-full w-full bg-gray-50 relative" data-id="element-73">
      {/* Header */}
      <header className="flex items-center px-4 py-4 text-white shadow-md z-20 shrink-0" style={{
      backgroundColor: '#134073'
    }} data-id="element-74">
        <button onClick={onBack} className="p-1 -ml-1 mr-2 active:bg-white/20 rounded-full transition-colors" data-id="element-75">
          <ChevronLeftIcon className="w-7 h-7" data-id="element-76" />
        </button>
        <div className="flex-1 min-w-0" data-id="element-77">
          <h1 className="font-bold text-lg truncate" data-id="element-78">Registro de Prendas</h1>
          <p className="text-xs text-white/80 truncate" data-id="element-79">{areaName}</p>
        </div>
      </header>

      {/* Sticky Total Bar */}
      <div className="sticky top-0 z-10 px-4 py-3 text-white flex justify-between items-center shadow-md" style={{
      backgroundColor: '#3d99d2'
    }} data-id="element-80">
        <span className="font-medium" data-id="element-81">Total a recolectar:</span>
        <span className="text-2xl font-bold" data-id="element-82">{totalItems} prendas</span>
      </div>

      {/* Form Content */}
      <div className="flex-1 overflow-y-auto p-4 pb-32" data-id="element-83">
        {/* Meta info */}
        <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100 mb-6 space-y-3" data-id="element-84">
          <div className="flex items-center text-gray-700" data-id="element-85">
            <CalendarIcon className="w-5 h-5 mr-3 text-gray-400" data-id="element-86" />
            <span className="font-medium" data-id="element-87">{dateString}</span>
          </div>
          <div className="flex items-center text-gray-700" data-id="element-88">
            <MapPinIcon className="w-5 h-5 mr-3 text-gray-400" data-id="element-89" />
            <span className="font-medium" data-id="element-90">{areaName}</span>
          </div>
        </div>

        <h2 className="text-lg font-bold text-gray-900 mb-4 px-1" style={{
        color: '#134073'
      }} data-id="element-91">
          Cantidades por Categoría
        </h2>

        {/* Categories List */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden mb-6" data-id="element-92">
          {CATEGORIES.map((cat, index) => <div key={cat.id} className={`flex items-center justify-between p-4 ${index !== CATEGORIES.length - 1 ? 'border-b border-gray-100' : ''}`} data-id="element-93">
              <span className="text-lg font-medium text-gray-800" data-id="element-94">
                {cat.name}
              </span>

              <div className="flex items-center gap-4" data-id="element-95">
                <button onClick={() => handleDecrement(cat.id)} className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center active:bg-gray-200 text-gray-600 border border-gray-200" data-id="element-96">
                  <MinusIcon className="w-5 h-5" data-id="element-97" />
                </button>

                <span className="w-8 text-center text-xl font-bold text-gray-900" data-id="element-98">
                  {counts[cat.id] || 0}
                </span>

                <button onClick={() => handleIncrement(cat.id)} className="w-10 h-10 rounded-full flex items-center justify-center active:opacity-80 text-white shadow-sm" style={{
              backgroundColor: '#3d99d2'
            }} data-id="element-99">
                  <PlusIcon className="w-5 h-5" data-id="element-100" />
                </button>
              </div>
            </div>)}

          {/* Otros */}
          <div className="border-t-4 border-gray-50 p-4 bg-gray-50/50" data-id="element-101">
            <div className="flex items-center justify-between mb-3" data-id="element-102">
              <span className="text-lg font-medium text-gray-800" data-id="element-103">Otros</span>

              <div className="flex items-center gap-4" data-id="element-104">
                <button onClick={() => setOtrosCount(Math.max(0, otrosCount - 1))} className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center active:bg-gray-200 text-gray-600 border border-gray-200" data-id="element-105">
                  <MinusIcon className="w-5 h-5" data-id="element-106" />
                </button>

                <span className="w-8 text-center text-xl font-bold text-gray-900" data-id="element-107">
                  {otrosCount}
                </span>

                <button onClick={() => setOtrosCount(otrosCount + 1)} className="w-10 h-10 rounded-full flex items-center justify-center active:opacity-80 text-white shadow-sm" style={{
                backgroundColor: '#3d99d2'
              }} data-id="element-108">
                  <PlusIcon className="w-5 h-5" data-id="element-109" />
                </button>
              </div>
            </div>
            {otrosCount > 0 && <input type="text" placeholder="Descripción de otros artículos..." className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:outline-none" style={{
            focusRingColor: '#3d99d2'
          }} value={otrosDesc} onChange={e => setOtrosDesc(e.target.value)} data-id="element-110" />}
          </div>
        </div>

        {/* Additional Info */}
        <div className="space-y-4 mb-8" data-id="element-111">
          <div data-id="element-112">
            <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-113">
              Observaciones (Opcional)
            </label>
            <textarea className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:outline-none min-h-[100px]" placeholder="Ej. Sábanas manchadas, bolsas rotas..." value={observaciones} onChange={e => setObservaciones(e.target.value)} data-id="element-114" />
          </div>

          <div data-id="element-115">
            <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-116">
              Responsable del Área
            </label>
            <input type="text" className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:outline-none h-12" placeholder="Nombre de quien entrega" value={responsable} onChange={e => setResponsable(e.target.value)} data-id="element-117" />
          </div>

          <div data-id="element-118">
            <div className="flex justify-between items-end mb-1" data-id="element-119">
              <label className="block text-sm font-bold text-gray-700" data-id="element-120">
                Firma
              </label>
              <button className="text-xs font-medium" style={{
              color: '#3d99d2'
            }} data-id="element-121">
                Limpiar
              </button>
            </div>
            <div className="w-full h-32 border-2 border-dashed border-gray-300 rounded-xl bg-white flex items-center justify-center" data-id="element-122">
              <span className="text-gray-400 font-medium" data-id="element-123">Firme aquí</span>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Action Bar */}
      <div className="absolute bottom-0 left-0 right-0 p-4 bg-white border-t border-gray-200 shadow-[0_-4px_10px_rgba(0,0,0,0.05)] pb-safe" data-id="element-124">
        <button onClick={onSave} disabled={totalItems === 0} className={`w-full h-14 rounded-xl flex items-center justify-center gap-2 text-lg font-bold shadow-lg transition-all ${totalItems === 0 ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'text-white active:scale-[0.98]'}`} style={totalItems > 0 ? {
        backgroundColor: '#134073'
      } : {}} data-id="element-125">
          <SaveIcon className="w-6 h-6" data-id="element-126" />
          Guardar Recolección
        </button>
      </div>
    </div>;
}